import React, { useCallback, useEffect, useState } from "react";
import { exportTable, LEDGER_EXPORT_COLUMNS } from "../../utils/downloadExcel";
import Main from "../Main";
import { fetchAepsLedgers } from "../../api/ledgersApi";
import { autoDateFormat } from "../../utils/autoDateFormate";
import { formatAmount } from "../../utils/formatAmount";
import { useNotify } from "../../context/NotifyContext";
import useSocketEvent from "../../socket/useSocketEvent";
import {
  ListingFilters,
  ListingPagination,
  SortableTh,
  AppBreadcrumbs,
  useListingState,
  LEDGER_STATUS_OPTIONS,
} from "../../components/listing";

const AepsLedgers = () => {
  const { notify } = useNotify();
  const listing = useListingState({ sortBy: "date", sortDir: "desc" });
  const [totalPages, setTotalPages] = useState(1);
  const [ledgers, setAddmoneyLeders] = useState([]);
  const [totalLedgers, setTotalbyAll] = useState(0);

  const fetch_ledgers = useCallback(async () => {
    try {
      const result = await fetchAepsLedgers(listing.query);
      if (result?.success) {
        const response = result?.data;
        setAddmoneyLeders(response?.ledgers || []);
        setTotalPages(response?.pagination?.totalPages || 1);
        setTotalbyAll(response?.pagination?.total || 0);
      } else {
        notify(result?.message || "Server Error", "error");
      }
    } catch (error) {}
  }, [listing.query, notify]);

  useEffect(() => {
    fetch_ledgers();
  }, [fetch_ledgers]);

  useSocketEvent("wallet_changed", fetch_ledgers);

  return (
    <Main showRightPanel={false}>
      <div className="mt-4 font-[Poppins]">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "MATM Module" },
            { label: "Wallet Statement" },
            { label: "12542697 (Anddy Makeover)" },
          ]}
        />

        <div className="ds-card mt-4 text-sm">
          <ListingFilters
            onClear={listing.clearFilters}
            startDate={listing.startDate}
            endDate={listing.endDate}
            onStartDate={listing.setStartDate}
            onEndDate={listing.setEndDate}
            search={listing.search}
            onSearch={listing.setSearch}
            searchPlaceholder="Search"
            status={listing.status}
            onStatus={listing.setStatus}
            statusOptions={LEDGER_STATUS_OPTIONS}
            onExport={() =>
              exportTable("aeps-ledger", LEDGER_EXPORT_COLUMNS, ledgers, notify)
            }
          />

          <div className="ds-table-wrap ds-scroll">
            <table className="ds-table ds-table-listing min-w-[700px]">
              <thead>
                <tr>
                  <th>S.NO</th>
                  <SortableTh
                    label="TRANS DATE"
                    sortKey="date"
                    activeKey={listing.sortBy}
                    direction={listing.sortDir}
                    onSort={listing.toggleSort}
                  />
                  <th>DESCRIPTION</th>
                  <SortableTh
                    label="DEBIT (₹)"
                    sortKey="debit"
                    activeKey={listing.sortBy}
                    direction={listing.sortDir}
                    onSort={listing.toggleSort}
                  />
                  <SortableTh
                    label="CREDIT (₹)"
                    sortKey="credit"
                    activeKey={listing.sortBy}
                    direction={listing.sortDir}
                    onSort={listing.toggleSort}
                  />
                  <SortableTh
                    label="BALANCE (₹)"
                    sortKey="closingBalance"
                    activeKey={listing.sortBy}
                    direction={listing.sortDir}
                    onSort={listing.toggleSort}
                  />
                </tr>
              </thead>
              <tbody>
                {ledgers?.length > 0 ? (
                  ledgers.map((item, index) => (
                    <tr key={item?._id || index}>
                      <td>{(listing.page - 1) * listing.limit + index + 1}</td>
                      <td>{autoDateFormat(item?.date)}</td>
                      <td>{item?.narration || "Opening Balance"}</td>
                      <td>{formatAmount(item?.debit)}</td>
                      <td>{formatAmount(item?.credit)}</td>
                      <td>{formatAmount(item?.closingBalance)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center text-[var(--text-muted)]">
                      No Ledgers Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <ListingPagination
            page={listing.page}
            limit={listing.limit}
            total={totalLedgers}
            totalPages={totalPages}
            onPageChange={listing.setPage}
            onLimit={listing.setLimit}
          />
        </div>
      </div>
    </Main>
  );
};

export default AepsLedgers;
